<script>
  import { getStores } from '$app/stores';

  const { page } = getStores();

  export let title = 'Portal';

  $: appName = $page.data.session.env.APP_NAME;
</script>

<svelte:head>
  <title>
    {title} | {appName}
  </title>
</svelte:head>
